export default (state, {
  instanceKey
}) => {
  let newFieldValue = {
    ...state
  };

  newFieldValue[`${instanceKey}_initializing`] = false;

  return newFieldValue;
};
